export enum RoleCodeEnum {
    SuperAdmin = 1,
    Admin = 2,
    User = 3,
}